import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "../vendors/gsap/ScrollSmoother";
import {SplitText} from "../vendors/gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);


class ScrollAnimations {
	static instance = null;

	static create(options) {
		if (ScrollAnimations.instance === null) {
			ScrollAnimations.instance = new ScrollAnimations(options);
		}
		return ScrollAnimations.instance;
	}

	static destroy(data) {
		if (ScrollAnimations.instance) {
			ScrollAnimations.instance.beforeDestroy();
			ScrollAnimations.instance = null;
		}
	}

	get defaultOptions() {
		return {
			selector: null,
			container: document
		}
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		if (this.options.container.querySelectorAll("[data-split-text-animate]").length > 0) {
			this.init();
		}
	}

	init() {
		if (this.options.container.querySelectorAll("[data-split-text-animate]").length > 0) {
			this.initSplitText();
			this.initResizeSplitText();
		}

	}

	initSplitText() {
		this.splitTextEls = [...this.options.container.querySelectorAll("[data-split-text-animate]")];
		this.splitTextArray = []
		this.splitTextEls.forEach(el => {
			const splitText = new SplitText(el, {type: 'lines'});
			const lines = splitText.lines;
			const toggleActions = el.hasAttribute('data-appear-reverse') ? `play none none reverse` : `play none none none`;
			this.splitTextArray.push(splitText)
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top 90%",
					end: "bottom 10%",
					scroller: "[data-scroll-container]",
					markers: false,
					toggleActions: toggleActions,
				},
				onComplete: () => {
					splitText.revert();
					this.splitTextEls.forEach((el) => {
						el.style.willChange = 'auto';
					});

					this.splitTextEls.forEach((el) => {
						el.style.willChange = 'auto';
					});

				}
			})
			tl.from(lines, {
				y: 40,
				opacity: 0,
				duration: 1,
				stagger: {
					amount: 0.5,
					ease: 'circ.out',
				},
			})

			// check if we have siblings with data-split-text-animate
			const siblings = el.parentNode.querySelectorAll(`[data-split-text-animate-next]`);
			if (siblings.length > 0) {
				tl.from(siblings, {
					y: 40,
					opacity: 0,
					duration: 0.8,
					ease: 'circ.out',
					clearProps: 'all',
				}, lines.length * 0.1)
			}
		})
	}

	initResizeSplitText() {
		let initTime;
		let delta = 200;
		let resizing = false;
		let prevWidth = window.innerWidth;
		window.addEventListener('resize', (e) => {
			if (window.innerWidth !== prevWidth) {
				prevWidth = window.innerWidth;
				initTime = new Date();
				if (resizing === false) {
					resizing = true;
					if (this.splitTextArray !== null) {
						if (this.splitTextArray.length > 0) {
							this.splitTextArray.forEach((st) => {
								st.revert(); // revert all split text
							})
						}
						setTimeout(this.checkResizeFinish, delta);
					}

				}
			}
		})

		this.checkResizeFinish = () => {
			if (new Date() - initTime < delta) {
				setTimeout(this.checkResizeFinish, delta);
			} else {
				resizing = false;
				this.initSplitText();
			}
		}
	}


	beforeDestroy() {

		if (this.splitTextEls !== null) {
			ScrollTrigger.getAll().forEach((trigger) => {
				trigger.kill(true);
			});

			this.splitTextEls = null;
			this.checkResizeFinish = null;
			this.splitTextArray = null;
		}


	}
}

export default ScrollAnimations;
